import { Stack } from '@/components/Layout'
import { ImagePageSection } from '@/shared/api-generated-types'
import Badges from '@/widgets/Badges'
import classNames from 'classnames/bind'
import * as styles from './style'

const cx = classNames.bind(styles)

export interface Props extends Partial<ImagePageSection> {
  className?: string
  minWidth?: boolean
}

const ImageBlock = ({
  items,
  className = '',
  minWidth = false,
  accessDisplay,
  isCommunityLedClass,
}: Props): JSX.Element | null => {
  const classes = cx({
    root: true,
    [className]: true,
    minWidth: minWidth,
  })
  if (!items) return null

  const accessImageOverlayStyle: string | undefined =
    accessDisplay?.__typename !== 'LockedAccessDisplay' ? `${styles.image}` : `${styles.lockedImage}`

  const OverlayIcons = (): JSX.Element => {
    return (
      <Stack x alignItems="center" justifyContent="flex-end" className={styles.overlayIcons}>
        {accessDisplay?.__typename === 'LockedAccessDisplay' ? (
          <img src={accessDisplay.iconUrl} className={`${styles.lockIcon} ml-xs`} />
        ) : (
          isCommunityLedClass && <Badges isCommunityLedClass theme="FULL" />
        )}
      </Stack>
    )
  }

  const DefaultImage = '/images/image-placeholder-large.png'

  if (items.length > 1) {
    return (
      <div className={classes}>
        <OverlayIcons />
        {items.map(({ imageUrl, altText }) => (
          <img src={imageUrl} alt={altText} className={styles.image} loading="eager" />
        ))}
      </div>
    )
  } else {
    return (
      <div className={classes}>
        <OverlayIcons />
        <div className={styles.overlay}>
          <img
            src={items[0]?.imageUrl || DefaultImage}
            alt={items[0]?.altText || 'Class image thumbnail'}
            className={accessImageOverlayStyle}
            loading="eager"
          />
        </div>
      </div>
    )
  }
}
export default ImageBlock
